export enum BettingStructure {
  NO_LIMIT = 'No Limit',
  POT_LIMIT = 'Pot Limit',
  FIXED_LIMIT = 'Fixed Limit',
  MIXED_LIMIT = 'Mixed Limit',
}

export enum GameType {
  // Standard poker variants
  NO_LIMIT_HOLDEM = 'No Limit Holdem',
  NO_LIMIT_HOLDEM_CAPPED = `${GameType.NO_LIMIT_HOLDEM} - Capped`,
  NO_LIMIT_SHORTDECK = 'No Limit Shortdeck',
  LIMIT_HOLDEM = 'Limit Holdem',
  PLO = 'PLO',
  PLO_CAPPED = `${GameType.PLO} - Capped`,
  PLO_8B = 'PLO 8/b',
  PLO_8B_CAPPED = `${GameType.PLO_8B} - Capped`,
  PLO_DOUBLE_BOARD = `${GameType.PLO} Double Board`,
  PLO5 = 'PLO5',
  PLO5_DOUBLE_BOARD = 'PLO5 Double Board',
  PLO5_CAPPED = `${GameType.PLO5} - Capped`,
  BIG_O = 'Big O',
  BIG_O_CAPPED = `${GameType.BIG_O} - Capped`,
  LIMIT_FIVE_CARD_DOUBLE_BOARD_OMAHA = 'Double Board 5 Card Omaha',
  PLO6 = 'PLO6',
  PLO6_CAPPED = `${GameType.PLO6} - Capped`,
  PLO6_DOUBLE_BOARD = `${GameType.PLO6} Double Board`,
  PLO6_8B = '6 Card PLO 8/b',
  PLO6_8B_CAPPED = `${GameType.PLO6_8B} - Capped`,
  NO_LIMIT_OMAHA_HIGH_LOW = 'No Limit Omaha High Low',
  LIMIT_OMAHA_HIGH = 'Limit Omaha High',
  LIMIT_OMAHA_DOUBLE_BOARD = 'Double Board Omaha',
  LIMIT_BIG_O = 'Limit Big O',
  LIMIT_OMAHA_8B = 'Limit Omaha 8/b',
  SEVEN_CARD_STUD = 'Seven Card Stud',
  STUD_8B = 'Stud 8/b',
  STUD_HI_LO_REGULAR = 'Stud hi/lo regular',
  RAZZ = 'Razz',
  TWO_SEVEN_RAZZ = '2-7 Razz',
  BADUGI = 'Badugi',
  BADEUCY = 'Badeucy 2-7',
  BADACEY = 'Badacey A-5',
  A5_TRIPLE_DRAW = 'A-5 Triple Draw',
  TWO_SEVEN_TRIPLE_DRAW = '2-7 Triple Draw',
  ARCHIE_66 = 'Archie 66',
  ARCHIE_99 = 'Archie 99',
  DRAMADUGI = 'DramaDugi',
  DRAMAHA_HIGH = 'Dramaha High',
  DRAMAHA_TWO_SEVEN = 'Dramaha 2-7',
  NL_TWO_SEVEN_SINGLE_DRAW = 'NL 2-7 Single Draw',
  NL_TWO_SEVEN_SINGLE_DRAW_CAPPED = `${GameType.NL_TWO_SEVEN_SINGLE_DRAW} - Capped`,

  // Bomb Pot variants
  NL_BOMB_POT = 'No Limit Holdem Bomb Pot',
  NL_DOUBLE_BOARD_BOMB_POT = 'No Limit Holdem Double Board Bomb Pot',
  PLO_BOMB_POT = 'PLO Bomb Pot',
  PLO_DOUBLE_BOARD_BOMB_POT = 'PLO Double Board Bomb Pot',
  PLO5_BOMB_POT = 'PLO5 Bomb Pot',
  PLO5_DOUBLE_BOARD_BOMB_POT = 'PLO5 Double Board Bomb Pot',
  PLO6_BOMB_POT = 'PLO6 Bomb Pot',
  PLO6_DOUBLE_BOARD_BOMB_POT = 'PLO6 Double Board Bomb Pot',

  // Mixed games
  AGAME_MIX = 'AGAME Mix',
  BLOOD_MIX = 'Blood Mix',
  ARIA_MIX = 'Aria Mix',
  HEROS_MIX = 'H.E.R.O.S. Mix',
  OE_MIX = 'O.E. Mix',
  TRIPLE_DRAW_MIX = 'Triple Draw Mix',
  SUPER_TRIPLE_DRAW_MIX = 'Super Triple Draw Mix',
  EIGHT_GAME_MIX = '8-Game Mix',
  EIGHT_GAME_MIX_UNCAPPED = '8-Game Mixed',
  FUN_MIX = 'Fun Mix',
  CIRCUS_MIX = 'Circus Mix',
  SUPER_CIRCUS_MIX = 'Super Circus Mix',
  STANDARD_MIX = 'Standard Mix',
  BIG_BET_MIX = 'Big Bet Mix',
  BIG_BET_MIX_CAPPED = 'Big Bet Mix - Capped',
  HYBRID_MIX = 'Hybrid Mix',
  DIRTY_DOZEN_MIX = 'Dirty Dozen Mix',
  CHOP_SHOP_MIX = 'Chop Shop Mix',
  TORSE_MIX = 'T.O.R.S.E. Mix',
  TOE_MIX = 'T.O.E. Mix',
  PLO_FUSION = 'PLO Fusion',
  PLO_MIX = 'PLO Mix',
  NLH_PLO_MIX = 'NLH/PLO Mix',
  DRAMAHA_MIX = 'Dramaha Mix',
}
